import { Injectable } from '@angular/core';
import { FeatureFlagsControllerService } from './api/notices';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private featureMap: Map<string, any> = new Map();

  constructor(private featureFlagsControllerService: FeatureFlagsControllerService) {
  }

  init(): Observable<{ [key: string]: object }> {
    return this.featureFlagsControllerService.getFeatureFlags().pipe(
      tap(response => this.featureMap = new Map(Object.entries(response)))
    );
  }

  isFeatureEnabled(featureName: string): boolean {
    const featureValue = this.featureMap.get(featureName);
    if (featureValue === undefined) {
      return false;
    } else if (typeof featureValue === 'boolean') {
      return featureValue;
    } else {
      return true;
    }
  }

  getFeatureValue(featureName: string): any {
    return this.featureMap.get(featureName);
  }
}
